import {SELECT_USER_FUNCTION_FOR_TRAININGS_FILTER} from '@/training/actions/trainingsSettings.js';

const app = (state = {}, action) => {
    switch (action.type) {
        case SELECT_USER_FUNCTION_FOR_TRAININGS_FILTER: {
            return {
                ...state,
                functionIdForTrainings: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default app;
